// extracted by mini-css-extract-plugin
export default {"logo":"logo--swiNm","logo-white":"logo-white--uH6jv","logoWhite":"logo-white--uH6jv","logo-dark":"logo-dark--3dsP6","logoDark":"logo-dark--3dsP6"};